import styles from './nav-bar.module.scss';
import { useNavigate } from 'react-router-dom';

interface Props {
  mode: 'back' | 'close';
  onClick?(): void;
  to?: string;
  link?: string;
}

const iconBack = (
  <svg width="24" height="25" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.707 5.029a1 1 0 1 1 1.414 1.414l-5.293 5.293h14.586a1 1 0 0 1 .993.883l.007.117a1 1 0 0 1-1 1H5.828l5.293 5.293a1 1 0 0 1 .084 1.32l-.084.094a1 1 0 0 1-1.414 0L2 12.736z"
      fill="#0C1831"
      fillRule="evenodd"
    />
  </svg>
);

const iconClose = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.049 4.335a1.143 1.143 0 0 1 1.616 1.616L13.616 12l6.05 6.049c.414.414.443 1.068.088 1.517l-.089.1a1.143 1.143 0 0 1-1.616 0L12 13.615l-6.049 6.05a1.143 1.143 0 0 1-1.517.088l-.1-.089a1.143 1.143 0 0 1 0-1.616L10.385 12l-6.05-6.049a1.143 1.143 0 0 1-.088-1.517l.089-.1a1.143 1.143 0 0 1 1.616 0L12 10.385z"
      fill="#0C1831"
      fillRule="evenodd"
    />
  </svg>
);

export function NavBar(props: Props) {
  const navigate = useNavigate();
  const icon = props.mode === 'back' ? iconBack : iconClose;

  const handleClick = () => {
    if (props.onClick) {
      props.onClick();
    }
    if (props.to) {
      navigate(props.to, { replace: true });
    }
  };

  let Component;
  if (props.link) {
    Component = (cProps: React.AnchorHTMLAttributes<HTMLAnchorElement>) => (
      <a {...cProps} href={props.link}>
        {cProps.children}
      </a>
    );
  } else {
    Component = 'button';
  }

  return (
    <div className={styles.Wrapper}>
      <Component
        className={styles.Navback}
        onClick={handleClick}
        data-testid={'nav-bar'}
      >
        {icon}
      </Component>
    </div>
  );
}

export default NavBar;
